module.exports = __webpack_public_path__ + "img/shouldercircumference.dbf4273e.jpeg";